// extracted by mini-css-extract-plugin
export default {"root":"AdminAgencyAccessContent_root__pKdSm"};